module.exports = __webpack_public_path__ + "static/media/WaterSoil.a823d633.logo";